import type { ReactNode } from 'react';
import { useAlisonRunReady } from '../AlisonRunProvider.js';
import { AlisonCornerPill } from './AlisonCornerPill.js';
import { AlisonIntroCard } from './AlisonIntroCard.js';
import { AlisonOutcomeLayer } from './AlisonOutcomeLayer.js';
import { AlisonRunDrawer } from './AlisonRunDrawer.js';
import { AlisonTakeover } from './AlisonTakeover.js';

export function AlisonRunLayer(): ReactNode {
  if (!useAlisonRunReady()) return null;
  return (
    <>
      <AlisonCornerPill />
      <AlisonIntroCard />
      <AlisonTakeover />
      <AlisonRunDrawer />
      <AlisonOutcomeLayer />
    </>
  );
}
